<!-- src/components/rota/EmailLinkFinishView.vue -->
<template>
  <div class="container email-link-finish-view">
    <div class="card email-link-finish-card">
      <div class="card-content">
        <div class="center-align">
          <span class="card-title">Signing you in…</span>
        </div>

        <p class="grey-text email-link-finish-copy" v-if="!error">
          Please wait while we verify your login link.
        </p>

        <p v-if="error" class="red-text email-link-finish-error">
          {{ error }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

import { auth } from "@/firebase";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";

const router = useRouter();
const error = ref("");

(async () => {
  try {
    const href = window.location.href;

    if (!isSignInWithEmailLink(auth, href)) {
      error.value = "This link is not valid or has already been used.";
      return;
    }

    const stored = window.localStorage.getItem("coredeck_emailForSignIn");
    const email = stored || window.prompt("Confirm your email to finish sign-in:");

    if (!email) {
      error.value = "Email is required to finish sign-in.";
      return;
    }

    await signInWithEmailLink(auth, String(email).trim().toLowerCase(), href);
    window.localStorage.removeItem("coredeck_emailForSignIn");

    // Router guard will lock rota-only users to rota-readonly
    await router.replace({ name: "Root" });
  } catch (e) {
    console.error(e);
    error.value = e?.message || "Failed to sign in with email link.";
  }
})();
</script>

<style scoped>
.email-link-finish-view {
  margin-top: 40px;
  max-width: 560px;
}

.email-link-finish-card {
  border-radius: 12px;
  overflow: hidden;
}

.email-link-finish-copy {
  margin-top: 10px;
}

.email-link-finish-error {
  margin-top: 12px;
  white-space: pre-wrap;
}

@media (max-width: 600px) {
  .email-link-finish-view {
    width: 94%;
    margin-top: 22px;
  }

  .email-link-finish-card .card-content {
    padding: 18px;
  }

  .email-link-finish-card .card-title {
    font-size: 1.45rem;
    line-height: 1.25;
  }
}
</style>
